import MyModal from "../../../Common/my-modal/my-modal.component";
import ModalForm from "./modal-form";
import { IAddPlanFormValues } from "../../../../common/validations/add-plan.validations";

interface AddPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddPlanModal = ({ isOpen, onClose }: AddPlanModalProps) => {
  const handleSubmit = async (values: IAddPlanFormValues) => {
    console.log("Form submitted with data:", values);
  };

  return (
    <MyModal show={isOpen} onHide={onClose}>
      <MyModal.Header
        closeButton
        onCrossClick={onClose}
        className="border-bottom"
      >
        <MyModal.HeaderTitle className="text-align-center w-100">
          Add Plan
        </MyModal.HeaderTitle>
      </MyModal.Header>
      <ModalForm onClose={onClose} onSubmit={handleSubmit} />
    </MyModal>
  );
};

export default AddPlanModal;
